import { useTranslation } from 'react-i18next';
import { useUserGeneratedContent } from '../../../../models/user-generated-contents/context';
import {
  PlainEditor,
  PlainEditorProps,
} from '../../../../components/ui/plain-editor';
import { MAXIMUM_SUMMARY_LENGTH } from '../../../../models/user-generated-contents/context';
import '../form.scss';

const trackingContext: PlainEditorProps['trackingContext'] = {
  contentSection: 'description',
};

const DescriptionInput = () => {
  const {
    userGeneratedContent,
    isPersisting,
    updateUserGeneratedContentFormState,
  } = useUserGeneratedContent();
  const { t } = useTranslation();

  const onTextChange = (summary: string) => {
    updateUserGeneratedContentFormState({ summary });
  };

  return (
    <PlainEditor
      className={'ugc-editor description'}
      aria-label={t('user_generated_content.field_description')}
      disabled={isPersisting}
      defaultValue={userGeneratedContent.summary || ''}
      maximumCharacter={MAXIMUM_SUMMARY_LENGTH}
      onChange={onTextChange}
      placeholder={t('user_generated_content.field_description_placeholder')}
      trackingContext={trackingContext}
    />
  );
};

export default DescriptionInput;
